module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('header', {
    staticClass: "c-toolbar"
  }, [_c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.fromModuleDefinition.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i-arrow icon-arrow-right"
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.toModuleDefinition.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "c-toolbar__title title"
  }, [_vm._v("Criar anúncio")])])])]) : _vm._e(), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Configuração para publicação dos anúncios"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.accountLoading
    }
  }), _vm._v(" "), _vm._l((_vm.announcementConfigurations), function(configuration) {
    return _c('panel', {
      staticClass: "blue-panel",
      attrs: {
        "title": configuration.label,
        "titleChangeble": true,
        "useAcordion": true,
        "acordionDefault": true
      }
    }, [_c('div', {
      attrs: {
        "slot": "header-right"
      },
      slot: "header-right"
    }, [(configuration.isEmpty) ? _c('span', {
      staticClass: "badge warning"
    }, [_vm._v("Preencher")]) : _vm._e(), _vm._v(" "), (configuration.isAlreadyExists) ? _c('span', {
      staticClass: "badge warning"
    }, [_vm._v("Repetido")]) : _vm._e()]), _vm._v(" "), _c('panel', [_c('div', {
      staticClass: "l-row"
    }, [_c('form-group', {
      attrs: {
        "label": _vm.$t('mercadoLivre.account.label'),
        "required": true
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (configuration.account),
        expression: "configuration.account"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(configuration, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeAccount(configuration.account)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.mercadoLivreAccounts), function(account) {
      return _c('option', {
        domProps: {
          "value": account
        }
      }, [_vm._v(_vm._s(((account.name) + " (" + (account.nickname) + ")")))])
    })], 2)]), _vm._v(" "), (configuration.account && _vm.officialStores[configuration.account.identifier] && _vm.officialStores[configuration.account.identifier].length) ? _c('form-group', {
      attrs: {
        "label": _vm.$t('mercadoLivre.officialStore.label'),
        "required": true
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (configuration.officialStore),
        expression: "configuration.officialStore"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(configuration, "officialStore", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.changeTitle]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.officialStores[configuration.account.identifier]), function(officialStore) {
      return _c('option', {
        domProps: {
          "value": officialStore
        }
      }, [_vm._v(_vm._s(officialStore.label))])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('form-group', {
      attrs: {
        "label": "Tipo",
        "required": true
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (configuration.announcementType),
        expression: "configuration.announcementType"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(configuration, "announcementType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.changeTitle]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.announcementTypeOptions), function(type) {
      return _c('option', {
        key: type,
        domProps: {
          "value": type
        }
      }, [_vm._v(_vm._s(_vm.$t(("mercadoLivre.types." + type + ".label"))))])
    })], 2)])], 1)])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "u-textRight"
  }, [_c('button', {
    staticClass: "btn btn--info",
    on: {
      "click": _vm.addAnnouncementConfiguration
    }
  }, [_vm._v("Adicionar nova")])])], 2), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('marketplace-announcement-product', {
      key: product,
      ref: "marketplaceProvideProduct",
      refInFor: true,
      attrs: {
        "announcementConfigurations": _vm.announcementConfigurations,
        "product": product,
        "fromModule": _vm.fromModule
      }
    })
  }), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('announcement.label')))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31e21be8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAnnouncement/Announcement.vue
// module id = 3032
// module chunks = 0